(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-category-blocks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-carousel')) {
    class EditorialCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
        };
        this.onPrev = () => this.scrollByItem(-1);
        this.onNext = () => this.scrollByItem(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);

        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.ro?.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      step() {
        const item = this.track.firstElementChild;
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      scrollByItem(dir) {
        this.track.scrollBy({ left: dir * this.step() });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const overflow = scrollWidth - clientWidth > 1;
        this.prev.hidden = !overflow;
        this.next.hidden = !overflow;
        if (!overflow) return;
        this.prev.disabled = scrollLeft <= 1;
        this.next.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
      }
    }
    customElements.define('editorial-carousel', EditorialCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
